<div class="item-selection-table-container">
  <!-- Title -->
  <ng-container *ngIf="title">
    <h4 class="font-weight-bold">{{ title | translate }}</h4>
  </ng-container>

  <!-- Search -->
  <div class="table-header d-flex flex-row justify-content-between">
    <div class="leftHeader">
      <div *ngIf="searchable" class="search-container mb-3">
        <div class="input-group mb-4 col-12 col-md-6 col-lg-4">
          <span class="input-group-text bg-white">
            <i class="icon-search-lg"></i>
          </span>
          <input
            type="text"
            class="form-control search-input"
            [placeholder]="searchPlaceHolder | translate"
            [(ngModel)]="searchTerm"
            [disabled]="disabled"
            (keyup)="handleSearch($event)" />
        </div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-responsive">
    <table class="table" [ngClass]="customTableClass">
      <thead>
        <tr>
          <th
            *ngFor="let column of columns"
            [sortable]="column.sortable && !disabled ? column.key : ''"
            [ngClass]="{ sortable: column.sortable }"
            (sort)="onSort($event)"
            [disabled]="disabled || !column.sortable"
            [style.width]="column.width">
            <div class="d-flex align-items-center gap-1">
              <span
                *ngIf="column.sortable && !disabled"
                class="icon-chevron-selector-vertical">
              </span>
              {{ column.title | translate }}
            </div>
          </th>

          <!-- Action Column -->
          <th style="width: 100px">
            {{ getActionLabel() | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Data Rows -->
        <ng-container *ngIf="!loading">
          <tr *ngFor="let row of currentPageData">
            <td *ngFor="let column of columns">
              {{ row[column.key] | translate }}
            </td>

            <!-- Action Cell -->
            <td class="action-cell">
              <button
                type="button"
                class="btn"
                [ngClass]="getButtonClass()"
                [disabled]="!canPerformAction(row) || disabled"
                (click)="handleItemAction(row)"
                [title]="getActionLabel()">
                <i *ngIf="shouldShowIcon()" [class]="getItemIcon(row)"></i>
                <span *ngIf="shouldShowLabel()" [class.ms-1]="shouldShowIcon()">
                  {{ getActionLabel() }}
                </span>
              </button>
            </td>
          </tr>
        </ng-container>

        <!-- Empty State -->
        <tr *ngIf="currentPageData.length === 0 && !loading">
          <td
            [colSpan]="columns.length + 1"
            class="text-center text-muted py-4">
            {{ emptyMessage | translate }}
          </td>
        </tr>

        <!-- Loading Shimmer -->
        <ng-container *ngIf="loading">
          <tr *ngFor="let item of shimmerTableSize">
            <td *ngFor="let column of columns">
              <div class="line loading-shimmer"></div>
            </td>
            <td>
              <div class="line loading-shimmer"></div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="w-100 mt-3 px-4" *ngIf="collectionSize > pageSize">
      <irembogov-data-table-pagination
        [minimalPagination]="minimalPagination"
        [showDirectionText]="true"
        [collectionSize]="collectionSize"
        [page]="currentPage"
        [disabled]="disabled"
        [pageSize]="pageSize"
        [showDropdown]="true"
        (paginatedValues)="onPageChange($event)">
      </irembogov-data-table-pagination>
    </div>
  </div>
</div>
